import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=652ebd71"
import script from "./ProjectPage.vue?vue&type=script&lang=ts"
export * from "./ProjectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports